import React from 'react';
import imgSmile from '../../assets/crying-face.png';

export const IconCry = () => {
    return <img src={imgSmile} alt="crying-face"/>
}
